import React from 'react';

import LightBulbSVG from './assets/light-bulb-off.svg';

export const LightBulbOff = () => (
  <div data-testid="light-bulb-off">
    <img src={LightBulbSVG} alt="" />
  </div>
);
